// extracted by mini-css-extract-plugin
export var askAiIcon = "_nt-9";
export var container = "_nt-0";
export var groupSeparator = "_nt-a";
export var highlight = "_nt-4";
export var resultIcon = "_nt-5";
export var resultItem = "_nt-7";
export var resultSubtitle = "_nt-3";
export var resultTitle = "_nt-2";
export var resultsList = "_nt-1";
export var searchGroup = "_nt-6";
export var selected = "_nt-8";